import { getState } from 'orch-communicator/store';

//START GENAI@GHCOPILOT
export const validateInitResponses = () => {
  const responses = getState().srcSdks.apiResponseCache.init;
  return (
    Object.keys(responses).length === 0 ||
    Object.values(responses).every(response => response === false)
  );
};
//END GENAI@GHCOPILOT
